import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { LabelContainerModel } from '../../../../../../models/aggregates/erp/label';
import { Core2Config } from '../../shared/core2Config';
import { ApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { LabelCriteriaModelQuery, LabelQueryCriteriaClass } from '../../../criteria';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LabelService extends BaseApiPublicLoginTemplateService<LabelContainerModel, LabelContainerModel, LabelContainerModel> {

  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'labels';
  static readonly LABEL_SUB_PATH = 'labels/';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'labels';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'labels';
    this.httpClient = http;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + LabelService.LABEL_SUB_PATH + BaseApiPublicLoginTemplateService.PUBLIC_EP;
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + LabelService.LABEL_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
  }


  getPromiseByCriteria(
    visa: ApiVisa, criteria?: LabelQueryCriteriaClass
  ): Promise<ApiResponseModel<LabelContainerModel>> {
    const buildDocCriteria = new LabelCriteriaModelQuery(criteria);
    console.log('buildDocCriteria: ', buildDocCriteria);
    console.log('OverRide: ', buildDocCriteria.query);
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    return this.httpClient.get<ApiResponseModel<LabelContainerModel>>
      (UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }

  getByCriteriaObservable(
    visa: ApiVisa, criteria?: LabelQueryCriteriaClass
  ): Observable<ApiResponseModel<LabelContainerModel>> {
    const buildDocCriteria = new LabelCriteriaModelQuery(criteria);
    const apiUrl = visa.api_domain_url + this.endpoint_path;
    const UrlByCriteria = apiUrl + '/query?' + buildDocCriteria.query;
    return this.httpClient.get<ApiResponseModel<LabelContainerModel>>
      (UrlByCriteria, this.getHttpHeader(visa));
  }


  updateImageAndDetails(formData: FormData, imageGuid, httpOptions) {
    const url = this.apiUrl + '/replace-file/' + imageGuid;
    return this.httpClient.put(url, formData, httpOptions);
  }

  replaceImageAndDetails(formData: FormData, imageGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/replace-file/' + imageGuid;
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  uploadImageAndDetails(formData: FormData, subjectGuid, httpOptions) {
    const url = this.apiUrl + '/add-files/' + subjectGuid;
    return this.httpClient.put(url, formData, httpOptions);
  }

  addImageAndDetails(formData: FormData, subjectGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/add-files/' + subjectGuid;
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }
  getImageDetails(imageGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/file/' + imageGuid;
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }
  deleteImageDetails(imageGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/file/' + imageGuid;
    return this.httpClient.delete(url, this.getHttpHeader(visa));
  }

  public getFile(extGuid: string, visa: ApiVisa): Observable<Blob> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/file/' + extGuid;

    return this.httpClient.get<Blob>(
      url,
      {
        headers: new HttpHeaders({
          authorization: visa.jwt_secret,
          responseType: 'blob',
          tenantCode: visa.tenantCode
        }),
        responseType: 'blob' as 'json'
      });
  }

  public getByCriteriaPost(dtoObject: any, visa: ApiVisa): Observable<PagingResponseModel<LabelContainerModel>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/query';
    }
    return this.httpClient.post<PagingResponseModel<LabelContainerModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
